import { Card, CardContent, CardFooter, CardHeader } from "../ui/card";
import { Button } from "../ui/button";
import { Paragraph } from "../ui/typography";

function ContinueWatch({ course, ...props }) {
  const isVideo = course.contentType.toLowerCase() === "video";
  const isQuiz = course.contentType.toLowerCase() === "quiz";

  let videoPercentage = Math.floor(
    (course.lastTimestamp * 100) / course.videoTotalTime
  );

  videoPercentage = videoPercentage >= 1 ? videoPercentage : 1;

  const getTestBtnStatus = ({ testStatus }) => {
    switch (testStatus) {
      case "COMING_SOON":
        return "Coming Soon";
      case "INCOMPLETE":
        return "Resume";
      case "COMPLETED":
        return "View Result";
      default:
        return "Start Now";
    }
  };

  return (
    <Card className="rounded-2xl overflow-hidden gap-y-0 py-0" {...props}>
      <CardHeader className="flex flex-col p-3 pb-0 h-23.5 bg-gradient-continue-watch-thumbnail">
        <Paragraph
          variant="b4"
          className="text-primary-foreground line-clamp-2 leading-normal"
          as="span"
        >
          {course.lessonName || course.title}
        </Paragraph>
      </CardHeader>

      <div className="h-0.5 w-full bg-grayscale-line">
        <span
          className="block h-full bg-primary"
          style={{ width: `${videoPercentage}%` }}
        />
      </div>

      <CardContent className="px-3 md:px-3 py-0">
        {isVideo && (
          <Paragraph variant="b5" className="text-grayscale-line">
            {videoPercentage}% Completed
          </Paragraph>
        )}
        {isQuiz && (
          <Paragraph variant="b5" className="text-grayscale-line">
            {course.noOfQuestions} Ques * {Number(course.duration) / 60} Mins
          </Paragraph>
        )}

        <Paragraph
          variant="b4"
          className="line-clamp-2 leading-normal h-9 md:h-11"
          as="span"
        >
          {course.lessonName || course.title}
        </Paragraph>
      </CardContent>

      <CardFooter className="p-2 md:px-3 md:pt-2 md:pb-3">
        <Button
          type="button"
          variant="outline"
          size="small"
          className="w-full py-1 h-7 rounded-sm hover:bg-primary hover:text-primary-foreground!"
        >
          {isVideo ? "Continue Watching" : getTestBtnStatus(course)}
        </Button>
      </CardFooter>
    </Card>
  );
}

export default ContinueWatch;
